import { Component } from '@angular/core';

@Component({
  selector: 'overlay-loading',
  template: `
    <div class="bubblingG">
      <span id="bubblingG_1">
      </span>
      <span id="bubblingG_2">
      </span>
      <span id="bubblingG_3">
      </span>
    </div>
  `,
  styles: [`
    :host {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 50%;
      transform: translateY(-10%);
    }

    .bubblingG {
      text-align: center;
      width:150px;
      height:94px;
      margin: auto;
    }

    .bubblingG span {
      display: inline-block;
      vertical-align: middle;
      width: 19px;
      height: 19px;
      margin: 47px auto;
      background: rgb(0,0,0);
      border-radius: 94px;
        -o-border-radius: 94px;
        -ms-border-radius: 94px;
        -webkit-border-radius: 94px;
        -moz-border-radius: 94px;
      animation: bubblingG 1.5s infinite alternate;
        -o-animation: bubblingG 1.5s infinite alternate;
        -ms-animation: bubblingG 1.5s infinite alternate;
        -webkit-animation: bubblingG 1.5s infinite alternate;
        -moz-animation: bubblingG 1.5s infinite alternate;
    }

    #bubblingG_1 {
      animation-delay: 0s;
        -o-animation-delay: 0s;
        -ms-animation-delay: 0s;
        -webkit-animation-delay: 0s;
        -moz-animation-delay: 0s;
    }

    #bubblingG_2 {
      animation-delay: 0.45s;
        -o-animation-delay: 0.45s;
        -ms-animation-delay: 0.45s;
        -webkit-animation-delay: 0.45s;
        -moz-animation-delay: 0.45s;
    }

    #bubblingG_3 {
      animation-delay: 0.9s;
        -o-animation-delay: 0.9s;
        -ms-animation-delay: 0.9s;
        -webkit-animation-delay: 0.9s;
        -moz-animation-delay: 0.9s;
    }



    @keyframes bubblingG {
      0% {
        width: 19px;
        height: 19px;
        background-color:rgb(0,0,0);
        transform: translateY(0);
      }

      100% {
        width: 45px;
        height: 45px;
        background-color:rgb(255,255,255);
        transform: translateY(-39px);
      }
    }

    @-o-keyframes bubblingG {
      0% {
        width: 19px;
        height: 19px;
        background-color:rgb(0,0,0);
        -o-transform: translateY(0);
      }

      100% {
        width: 45px;
        height: 45px;
        background-color:rgb(255,255,255);
        -o-transform: translateY(-39px);
      }
    }

    @-ms-keyframes bubblingG {
      0% {
        width: 19px;
        height: 19px;
        background-color:rgb(0,0,0);
        -ms-transform: translateY(0);
      }

      100% {
        width: 45px;
        height: 45px;
        background-color:rgb(255,255,255);
        -ms-transform: translateY(-39px);
      }
    }

    @-webkit-keyframes bubblingG {
      0% {
        width: 19px;
        height: 19px;
        background-color:rgb(0,0,0);
        -webkit-transform: translateY(0);
      }

      100% {
        width: 45px;
        height: 45px;
        background-color:rgb(255,255,255);
        -webkit-transform: translateY(-39px);
      }
    }

    @-moz-keyframes bubblingG {
      0% {
        width: 19px;
        height: 19px;
        background-color:rgb(0,0,0);
        -moz-transform: translateY(0);
      }

      100% {
        width: 45px;
        height: 45px;
        background-color:rgb(255,255,255);
        -moz-transform: translateY(-39px);
      }
    }
  `]
})
export class OverlayLoadingComponent {}
